<template>
  <b-nav-item-dropdown
    right
    toggle-class="d-flex align-items-center dropdown-user-link"
    class="dropdown-user"
  >
    <template #button-content>
      <div class="d-sm-flex d-none user-nav">
        <p class="user-name font-weight-bolder mb-0">
          {{ userData.fullName || userData.username }}
        </p>
        <span class="user-status">{{ userData.role }}</span>
      </div>
      <b-avatar
        size="40"
        :src="userData.avatar"
        variant="light-primary"
        badge
        class="badge-minimal"
        badge-variant="success"
      >
        <feather-icon
          v-if="!userData.fullName"
          icon="UserIcon"
          size="22"
        />
      </b-avatar>
    </template>
    <b-dropdown-divider />

    <b-dropdown-item
      :to="{ name: 'perfil' }"
      link-class="d-flex align-items-center"
    >
      <feather-icon
        size="16"
        icon="SettingsIcon"
        class="mr-50"
      />
      <span>Perfil</span>
    </b-dropdown-item>

    <b-dropdown-item
      link-class="d-flex align-items-center"
      @click="logout"
    >
      <feather-icon
        size="16"
        icon="LogOutIcon"
        class="mr-50"
      />
      <span>Salir</span>
    </b-dropdown-item></b-nav-item-dropdown>
</template>

<script>
import useJwt from "@/auth/jwt/useJwt"
import { initialAbility } from "@/libs/acl/config"
import {
  BAvatar,
  BDropdownDivider,
  BDropdownItem,
  BNavItemDropdown,
} from "bootstrap-vue"

export default {
  components: {
    BNavItemDropdown,
    BDropdownItem,
    BDropdownDivider,
    BAvatar,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("userData")),
    }
  },
  created() {},
  methods: {
    logout() {
      const token = localStorage.getItem("accessToken")

      this.$http
        .post("/auth/token-delete", {
          idusuario: this.userData.id,
          token,
        })
        .then(() => {
          localStorage.removeItem(
            useJwt.jwtConfig.storageTokenKeyName,
          )
          localStorage.removeItem(
            useJwt.jwtConfig.storageRefreshTokenKeyName,
          )

          localStorage.removeItem("userData")

          this.$ability.update(initialAbility)

          this.$router.push({ name: "auth-login" })
        })
        .catch((error) => {
          this.$swal({
            title: "Error",
            text: error.response.data.error,
            icon: "error",
            customClass: {
              confirmButton: "btn btn-primary",
            },
            buttonsStyling: false,
          })
        })
    },
  },
}
</script>
